// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function SvgIcon(theme) {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeLarge: {
          width: 32,
          height: 32,
          fontSize: "inherit",
        },
      },
    },
  }
}
